import { css } from '@emotion/core'
import { FS, LINE_HEIGHT, WHITE, mq } from './style'

import AvenirBold from '../fonts/AvenirNextLTPro-BoldCn.woff'
import AvenirBold2 from '../fonts/AvenirNextLTPro-BoldCn.woff2'
import AbenirHeavy from '../fonts/AvenirNextLTPro-HeavyCnIt.woff'
import AbenirHeavy2 from '../fonts/AvenirNextLTPro-HeavyCnIt.woff2'

export default css`
    @font-face {
        font-family: 'Avenir';
        src: url(${AvenirBold2}) format('woff2'),
            url(${AvenirBold}) format('woff');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'Avenir';
        src: url(${AbenirHeavy2}) format('woff2'),
            url(${AbenirHeavy}) format('woff');
        font-weight: 800;
        font-style: normal;
    }

    html {
        background-color: black;
        box-sizing: border-box;
        color: ${WHITE};
        font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
        font-size: 8px;
        line-height: ${LINE_HEIGHT};

        ${mq.small(css`
            font-size: ${FS}px;
        `)};
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    body {
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
    }

    a {
        color: inherit;
        text-decoration: inherit;
    }

    button {
        appearance: none;
        background: transparent;
        border: 0;
        cursor: pointer;
        outline: 0;
        padding: 0;
    }
`

/*
.sprite {
	display: inline-block;
	overflow: hidden;
	background-repeat: no-repeat;
	background-image: url(test.png);
	animation-fill-mode: forwards;
	animation-name: playB;
	animation-duration: 0.2s;
	animation-timing-function: steps(6);
}

.Composition-2_100 {width:48px; height:47px; background-position: -0px -0px}
.Composition-2_101 {width:48px; height:47px; background-position: -48px -0px}
.Composition-2_102 {width:48px; height:47px; background-position: -96px -0px}
.Composition-2_103 {width:48px; height:47px; background-position: -144px -0px}
.Composition-2_104 {width:48px; height:47px; background-position: -192px -0px}
.Composition-2_105 {width:48px; height:47px; background-position: -240px -0px}
.Composition-2_106 {width:48px; height:47px; background-position: -288px -0px}

.sprite.play {
	animation-name: play;
}

*/
